import { type Configuration, LogLevel } from '@azure/msal-browser';
import { runtimeConfig } from '@/runtimeConfig';

const tenantId = runtimeConfig.MsalTenantId.Or(
  'b5a920d6-7d3c-44fe-baad-4ffed6b8774d',
);
export const msalConfig: Configuration = {
  auth: {
    clientId: runtimeConfig.MsalClientId.asString(),
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${globalThis.location.origin}/redirect.html`,
    postLogoutRedirectUri: globalThis.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};
